import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      hideTabBar: true,
    },
  },
  {
    path: "/about",
    name: "about",

    component: function () {
      return import("../views/UserView.vue");
    },
    meta: {
      hideTabBar: true,
    },
  },
  {
    path: "/detail",
    name: "detail",

    component: function () {
      return import("../views/DetailView.vue");
    },
  },
  {
    path: "/complaint",
    name: "complaint",

    component: function () {
      return import("../views/complaintView.vue");
    },
  },
  {
    path: "/login",
    name: "login",

    component: function () {
      return import("../views/LoginView.vue");
    },
  },
  {
    path: "/waitPay",
    name: "waitPay",
    component: function () {
      return import("../views/WaitPayView.vue");
    },
  },
  {
    path: "/orders",
    name: "orders",
    component: function () {
      return import("../views/OrdersView.vue");
    },
  },
  {
    path: "/orderdetail",
    name: "orderdetail",
    component: function () {
      return import("../views/OrderDetail.vue");
    },
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: function () {
      return import("../views/paySuccess.vue");
    },
  },
  {
    path: "/fail",
    name: "fail",
    component: function () {
      return import("../views/payFail.vue");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
